module.exports = __webpack_public_path__ + "img/google.ca2f7db2.png";